/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 浅色移动端主题文件
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-07-14 16:35:28
 * @LastEditTime: 2023-05-18 17:01:46
 * @FilePath: /client-h5-v2/src/theme/xiaole/mobile.ts
 */
export default {
  'name': 'light-mobile',
  // 默认全局背景色
  'default-global-bg-color': '#ffffff',
  // 纯文本颜色
  'kd-text-color': 'red',
  'kd-text-hover-color': 'red',
  'kd-text-tips-color': '#4a4a4a',
  // 链接颜色
  'kd-link-color': '#1582df',
  'kd-link-hover-color': '#61a3dc',
  'kd-link-active-color': '#749ABA',
  // icon 颜色
  'kd-icon-color': '#4a4a4a',
  // 按钮
  'kd-btn-text-color': '#ffffff',
  'kd-btn-text-hover-color': '#ffffff',
  'kd-btn-bg-color': '#6a90c8',
  'kd-btn-bg-hover-color': '#2f6bc4',
  'kd-btn-bd-color': '#6a90c8',
  'kd-btn-bd-hover-color': '#2f6bc4',
  // 顶部导航
  'kd-nav-bg-color': '#ffffff',
  'kd-nav-text-color': '#4a4a4a',
  'kd-nav-text-hover-color': '#2f6bc4',
  // 侧边栏
  'kd-slider-nav-bg-color': 'linear-gradient(161deg, #ffffff 0%, #ffffff 100%)',
  'kd-slider-nav-bd-color': '#ccc',
  'kd-slider-qlink-text-color': '#000000',
  'kd-slider-qlink-text-hover-color': '#236ca9',
  'kd-slider-logo-text-color': '#000000',
  'kd-slider-qlink-bg-color': '#4b88bb',
  'kd-slider-qlink-bg-hover-color': '#236ca9',
  // 对话区域header
  'kd-dialog-header-banner-text-color': '#11142D',
  'kd-dialog-header-banner-bg-color': '#ffffff',
  'kd-dialog-header-banner-bd-color': '#ffffff',
  // 对话区域middle
  'kd-dialog-middle-bg-color': '#EDEDED',
  'kd-dialog-middle-bd-color': '#ffffff',
  // 对话区域bottom（input框）
  'kd-input-wrap-bg-color': '#ffffff',
  'kd-input-text-color': '#000000',
  'kd-input-bg-color': '#ffffff',
  'kd-input-bd-color': '#dcdfe6',
  'kd-input-bd-hover-color': '#c0c4cc',
  // 对话答案模版
  'kd-template-bg-color': '#ffffff',
  'kd-template-text-color': '#434652',
  'kd-template-body-color': '#767B8F',
  'kd-template-bd-color': '#cccccc',
  // send 按钮（对话框主体）
  'kd-send-btn-text-color': '#ffffff',
  'kd-send-btn-bg-color': '#4E6EF2',
  'kd-send-btn-bg-hover-color': '#6d84e3',
  'kd-send-btn-bd-color': '#4E6EF2',
  'kd-send-btn-bd-hover-color': '#6d84e3',
  'kd-send-tips-text-color': '#D1D1D1',
  // survey模版主题
  'kd-survey-bg-color': '#ffffff',
  'kd-survey-text-color': '#000000',
  // survey模版主题-单选框横向的样式
  'kd-survey-radio-text-color': '#000000',
  'kd-survey-radio-active-text-color': '#000000',
  'kd-survey-radio-bg-color': 'rgba(0,0,0,0)',
  'kd-survey-radio-active-bg-color': '#FFCA7A',
  'kd-survey-radio-bd-color': '#A0A0A0',
  'kd-survey-radio-active-bd-color': '#FFCA7A',
  // survey模版主题-多选框横向的样式
  'kd-survey-checkbox-text-color': '#000000',
  'kd-survey-checkbox-active-text-color': '#000000',
  'kd-survey-checkbox-bg-color': 'rgba(0,0,0,0)',
  'kd-survey-checkbox-active-bg-color': '#FFEBCC',
  'kd-survey-checkbox-bd-color': '#A0A0A0',
  'kd-survey-checkbox-active-bd-color': '#FFEBCC',
  // 智联-survey 客服满意度评价样式
  'kd-survey-zhilian-engineerInfo-bg-color': 'rgba(213, 238, 255, 1)',
  'kd-survey-zhilian-engineerInfo-text-color': 'rgba(8, 41, 249, 1)',
  'kd-user-template-bg-color': '#3F8CFF'
}

